// This file was automatically generated from uiwidget.GroupedNav.html.
// Please don't edit this file by hand.

goog.provide('el8.template.uiwidget.GroupedNav');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.GroupedNav.groupNav = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ol class="grouped-nav-title el8BlockNavMenuSection ebs-nav ebs-nav-pills ebs-nav-stacked" data-title="', soy.$$escapeHtml(opt_data.title), '">', (opt_data.title) ? '<li class="el8NavMenuTitle">' + soy.$$escapeHtml(opt_data.title) + '</li>' : '', '</ol>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.GroupedNav.sectionNav = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="grouped-nav-item el8NavMenuItem" data-name="', soy.$$escapeHtml(opt_data.name), '"><a>', soy.$$escapeHtml(opt_data.label), (opt_data.isBeta) ? '<div class="el8GoogleSyncNavLink el8Tag--beta">Beta</div>' : '', (opt_data.isNew) ? '<div class="el8GoogleSyncNavLink el8Tag--beta">New</div>' : '', '</a></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.GroupedNav.sectionContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="grouped-nav-content el8MainFormSection" data-name="', soy.$$escapeHtml(opt_data.name), '"></div>');
  if (!opt_sb) return output.toString();
};
